import { Dialog } from 'primereact/dialog';
import { PlanDetailsType } from 'src/types/types';
import { CreditBalancePanel } from './CreditBalancePanel';
import { BuyCreditsPanel } from './BuyCreditsPanel';

type UsageCreditsDialogProps = {
  visible: boolean;
  onHide: () => void;
  planDetails: PlanDetailsType | null;
  subscription: any;
};

export const UsageCreditsDialog = ({
  visible,
  onHide,
  planDetails,
  subscription,
}: UsageCreditsDialogProps) => {
  return (
    <Dialog
      header="Usage & Ticket Packs"
      visible={visible}
      onHide={onHide}
      draggable={false}
      style={{ width: '1000px', maxWidth: '90vw' }}
      contentStyle={{ padding: '1.5rem' }}
    >
      {/* Info banner */}
      <div className="mb-4 p-3 border-round" style={{ backgroundColor: '#f0f9ff' }}>
        <p className="m-0 text-sm" style={{ color: '#5a6c7d' }}>
          Subscription tickets reset monthly. Ticket packs don&apos;'t expire monthly and are used
          after your subscription.
        </p>
      </div>

      {/* Two-column layout */}
      <div className="grid">
        <div className="col-12 md:col-6">
          <CreditBalancePanel planDetails={planDetails} subscription={subscription} />
        </div>
        <div className="col-12 md:col-6">
          <BuyCreditsPanel onClose={onHide} />
        </div>
      </div>
    </Dialog>
  );
};
